import request from 'axios'
import {MessageBox} from 'element-ui';
import element from 'element-ui'
// import store from '@/store'
import Cookies from 'js-cookie'
import md5 from 'js-md5'
import stringify from 'json-stringify-safe'
import parse from 'parse-json'
// import { getToken } from '@/utils/auth'

// create an axios instance
const axios = request.create({
    baseURL: process.env.BASE_API // api的base_url
    // timeout: 10000 // request timeout
})

function calculateSign(a, b, c, d) {
    // var AAA = c || {}
    // b = JSON.parse( JSON.stringify(a) )
    var AAA = {}
    if (c) {
        AAA = parse(stringify(c)) || {}
    }

    AAA.t = new Date().getTime()
    AAA.appkey = a
    var newkey = Object.keys(AAA).sort()
    var newString = ''
    for (var i = 0; i < newkey.length; i++) {
        newString += AAA[newkey[i]]
    }
    if (d) {
        var nd
        if (typeof (d) === 'string') {
            nd = d
        } else {
            nd = stringify(d)
        }
        if (nd.length > 1024 * 5) {
            newString += nd.length
        } else {
            newString += nd
        }
    }
    newString += b
    var sign = md5(newString)
    AAA.sign = sign
    return AAA
}
let toString = Object.prototype.toString
function $trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}
// 请求参数去两端空格
function handleParams(obj) {
  if(typeof obj == 'string') {
    return obj
  }
  for(let p in obj) {
    if(toString.call(obj[p]) == "[object Object]") {
      obj[p] = handleParams(obj[p])
    } else if (toString.call(obj[p]) == "[object Array]") {
      for(let i = 0; i < obj[p].length; i++) {
        if(toString.call(obj[p]) == "[object Object]") {
          obj[p][i] = handleParams(obj[p][i])
        } else if (typeof obj[p][i] == 'string') {
          obj[p][i] =  $trim(obj[p][i])
        }
      }
    }else { // 字符串 || 数字
        if(typeof obj[p] == 'string') {
          obj[p] = $trim(obj[p])
        }
    }
  }
  return obj
}
// request interceptor
axios.interceptors.request.use(config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   config.headers['X-Token'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    // }
    let {data,params} = config
    if(data) {
      config.data = handleParams(data)
    }
    if(params) {
      config.params = handleParams(params)
    }
    var appkey = Cookies.get('_ztadmin' + '_appkey') || '20190312'
    var appsecret = Cookies.get('_ztadmin' + '_secret') || 'AE13B440A538A5E7C7513043BAF22065'
    var sign
    if (config.method.toLowerCase() !== 'get') {
        sign = calculateSign(appkey, appsecret, {}, config.data)
    } else {
        sign = calculateSign(appkey, appsecret, config.params)
    }
    config.headers['sign'] = sign.sign
    config.headers['t'] = sign.t
    config.headers['appkey'] = appkey
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone interceptor
axios.interceptors.response.use(
    msg => {
        let result = msg.data;
        let jsonStr = location.href;
        if (result) {
            if (result.code == 101) {
                MessageBox.confirm(result.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //location.href='/login.html?redirectUrl='+jsonStr;//正式
                    location.href = '/login.html#/redirectUrl=' + encodeURIComponent(jsonStr);
                }).catch(() => {
                    console.log('已取消');
                });
            } else if (result.code == 102) {
                MessageBox.confirm(result.msg, '提示', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //location.href='/login.html?redirectUrl='+jsonStr;//正式
                    // location.href='/login.html#/redirectUrl='+encodeURIComponent(jsonStr);
                    console.log('添加后台链接');
                }).catch(() => {
                    console.log('已取消');
                });
            } else if (result.code == 103) {
                MessageBox.confirm(result.msg, '提示', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //location.href='/login.html?redirectUrl='+jsonStr;//正式
                    location.href = '/login.html#/redirectUrl=' + encodeURIComponent(jsonStr);
                }).catch(() => {
                    console.log('已取消');
                });
            } else if (result.code == 104) {
                MessageBox.confirm(result.msg, '提示', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //location.href='/login.html?redirectUrl='+jsonStr;//正式
                    location.href = '/login.html#/redirectUrl=' + encodeURIComponent(jsonStr);
                }).catch(() => {
                    console.log('已取消');
                });

            }else if (result.code == 3) {
                MessageBox.confirm(result.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //location.href='/login.html?redirectUrl='+jsonStr;//正式
                    location.href='/user/index.html#/personal_center/pidsettings?redirectUrl='+encodeURIComponent(jsonStr);
                }).catch(() => {
                    console.log('已取消');
                });
            }else if (result.code == 0) {
                return msg;
            }else {
                return msg;
            }
        }
    }
)
/**
 * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
 */
    //  const res = response.data;
    //     if (res.code !== 20000) {
    //       Message({
    //         message: res.message,
    //         type: 'error',
    //         duration: 5 * 1000
    //       });
    //       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
    //           confirmButtonText: '重新登录',
    //           cancelButtonText: '取消',
    //           type: 'warning'
    //         }).then(() => {
    //           store.dispatch('FedLogOut').then(() => {
    //             location.reload();// 为了重新实例化vue-router对象 避免bug
    //           });
    //         })
    //       }
    //       return Promise.reject('error');
    //     } else {
    //       return response.data;
    //     }

    // error => {
    //   console.log('err' + error)// for debug
    //   Message({
    //     message: error.message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject(error)
    // })
//export const PostUrl = 'http://192.168.8.62:60866';
export const PostUrl = 'http://192.168.11.151:8089';
export default axios
